<template>
  <Layout>
    <div
      class="page-title-box d-flex align-items-center justify-content-between"
    >
      <h4 class="mb-0">Poster</h4>
      <span @click="$router.go(-1)" style="cursor: pointer; color: grey"
        >Back</span
      >
    </div>
    <div class="row" id="notification">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div
              class="page-title-box d-flex align-items-center justify-content-between"
            >
              <h4 class="mb-0">Poster Details</h4>
            </div>
            <div class="card">
              <div class="card-body">
                <div class="row" v-if="Posters.length > 0">
                  <div
                    class="col-md-4 col-4"
                    v-for="(poster, index) in Posters"
                    :key="index"
                  >
                    <div class="card">
                      <div class="card-header">
                        <h3>{{ poster.title }}</h3>
                      </div>
                      <!-- <div class="card-body" @click="showPosterDetails(poster.id)">
                        <img 
                          class="img-thumbnail"
                          :src="poster.poster_image"
                        />
                      </div> -->
                      <div class="card-body">
                        <img @click="showPosterDetails(poster.id,poster.preview_html_content,poster.download_html_content)"
                          class="img-thumbnail"
                          :src="poster.poster_image"
                        />
                      </div>
                    </div>
                    <!-- Toggle Details Section -->
                    <transition name="fade">
                          <div v-if="activePosterId === poster.id" class="mt-3 p-3 bg-light rounded shadow">
                            <!-- <h5 class="text-primary">Poster Title: {{ poster.title }}</h5> -->
                            <!-- <h5 class="text-primary">Doctor Name: {{ member_data.fname }} {{ member_data.lname }}</h5> -->
                            
                            <!-- <h5 class="text-primary">Speciality: {{ member_data.speciality_name }}</h5> -->
                            <!-- <h5 class="text-primary">Professional Headline: {{ member_data.professional_headline }}</h5> -->
                            <!-- <h5 class="text-primary">Mobile No.: +{{ member_data.country_code }}-{{ member_data.mobile_number }}</h5> -->
                            <!-- <b-button
                              class="btn btn-primary" @click="showPreview"
                              >Preview Html</b-button
                            > -->
                            <!-- <a
                              style="padding: 10px" @click.prevent="downloadPoster(member_data.id, poster.id)"
                              ><button class="btn btn-primary">Download</button></a
                            > -->
                            <!-- <a
                              style="padding: 10px" @click="showModal = true"
                              ><button class="btn btn-primary">Download</button></a
                            > -->
                            <!-- If qr_status is 0, download directly -->
                            <b-button
                              v-if="poster.qr_status == 0"
                              variant="primary"
                              @click="downloadPoster(member_data.id, poster.id, poster.download_html_content, poster.qr_status)"
                            >
                              Download
                            </b-button>

                            <!-- If qr_status is 1, open modal for QR input -->
                            <b-button
                              v-else
                              variant="primary"
                              @click="showModal = true"
                            >
                              Generate & Download
                            </b-button>

                            <!-- <b-button class="btn btn-primary" @click="showModal = true">
                              QR Code Generate
                            </b-button> -->

                            <!-- Modal -->
                            <b-modal v-model="showModal" title="Generate QR Code" hide-footer @hidden="onQrModalClose">
                              <b-form @submit.prevent="generateQrCode">
                                <b-form-group label="Enter URL" label-for="urlInput">
                                  <b-form-input
                                    id="urlInput"
                                    v-model="inputUrl"
                                    placeholder="https://example.com"
                                    required
                                  ></b-form-input>
                                </b-form-group>

                                <b-button type="submit" variant="success">Generate</b-button>
                                <a v-if="qrImage"
                              style="padding: 10px" @click.prevent="downloadPoster(member_data.id, poster.id,poster.download_html_content,poster.qr_status)"
                              ><button class="btn btn-primary">Download</button></a
                            >
                              </b-form>

                              <div v-if="qrImage" class="mt-3 text-center">
                                <!-- <img :src="qrImage" alt="QR Code" /> -->
                                <div class="mt-2">
                                  <a :href="qrImage" download="qr-code.png">
                                    <!-- <b-button variant="primary">Download</b-button> -->
                                  </a>
                                </div>
                              </div>
                            </b-modal>
                          </div>
                        </transition>
                        <div v-if="previewEmail && previewHtml && activePosterId === poster.id">
                          <label class="my-3 d-block text-center"
                            >Preview of HTML Content</label
                          >
                          <div
                            v-html="previewHtml"
                            class="d-flex align-items-center"
                          ></div>
                        </div>
                  </div>
                </div>
              </div>
            </div>
            




          </div>







        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Layout from "../../layouts/main";
import MixinRequest from "../../../mixins/request";
import liveEvent from "../../../mixins/ModuleJs/member-list";
// import {
//   members
// } from "../../../js/path";
export default {
  mixins: [MixinRequest, liveEvent],
  name: "show-certificates",
  data() {
    return {
      poster: [],
      // activePosterId: null,
      // member_data: []
    };
  },
  components: {
    Layout,
    //   PageHeader
  },
  methods: {
    // showPosterDetails(id) {
    //   // Toggle logic: if same ID is clicked, hide it
      // this.activePosterId = this.activePosterId === id ? null : id;
      // this.fetchSlider(this.$route.params.id);
    // },
    // async fetchSlider(id) {
    //   this.$store.commit("loader/updateStatus", true);
    //   try {
    //     let url = members.getMembers + "/" + id;
    //     const data = await this.getRequest(url);
    //     if (data.status) {
    //       this.member_data = data.response;
    //     }
    //   } catch (err) {
    //     console.log(err);
    //     this.$store.commit("toast/updateStatus", {
    //       status: true,
    //       icon: "error",
    //       title: err.data ? err.data.message : "Please try again!",
    //     });
    //   }
    //   this.$store.commit("loader/updateStatus", false);
    // },
    mounted() {
      this.fetchPosters();
      console.log(this.member_data);
    },
  },
};
</script>
<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: all 0.3s ease;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
